module.exports = __webpack_public_path__ + "static/media/4-iron.6232d2a9.png";